<div class="characteristics-container">
  @if (this.data.characteristic) {
    <h3 mat-dialog-title class="header-container">Update Characteristics</h3>
  } @else {
    <h3 mat-dialog-title class="header-container">Add Default Characteristics</h3>
  }

  <div class="sub-head pl-4">Provide preset characteristics that are not customizable.</div>

  <form [formGroup]="characteristicsForm" (ngSubmit)="onSubmit()">
    <mat-dialog-content class="pt-2 pb-4">
      <div class="d-flex flex-column mb-3 pt-2">
        <div class="">
          <label class="form-label pl-0"><span class="status-span">*</span>Characteristic:</label>
        </div>
        <div class="mt-1">
          <input
            type="text"
            class="form-control"
            placeholder="Eg: Enter the default characteristic"
            formControlName="newCharacteristics"
            [ngClass]="{
              'input-error':
                characteristicsForm.get('newCharacteristics')?.invalid &&
                (characteristicsForm.get('newCharacteristics')?.touched ||
                  characteristicsForm.get('newCharacteristics')?.dirty),
            }"
          />
          @if (
            characteristicsForm.get('newCharacteristics')?.errors?.['required'] &&
            (characteristicsForm.get('newCharacteristics')?.touched ||
              characteristicsForm.get('newCharacteristics')?.dirty)
          ) {
            <div class="d-flex mt-2 errorText gap-2">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>Characteristic cannot be empty.</p>
            </div>
          }
          @if (characteristicsForm.get('newCharacteristics')?.errors?.['minlength']) {
            <div class="d-flex mt-2 errorText gap-2">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>Characteristic must be at least 3 characters long.</p>
            </div>
          }
          @if (characteristicsForm.get('newCharacteristics')?.errors?.['maxlength']) {
            <div class="d-flex mt-2 errorText gap-2">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>Characteristic can not exceed 20 characters.</p>
            </div>
          }
        </div>
        <div class="mt-3">
          <label class="form-label pl-0"><span class="status-span">*</span>Value:</label>
        </div>
        <div class="mt-1">
          <input
            type="text"
            class="form-control"
            placeholder="Enter the value"
            formControlName="value"
            [ngClass]="{
              'input-error':
                characteristicsForm.get('value')?.invalid &&
                (characteristicsForm.get('value')?.touched ||
                  characteristicsForm.get('value')?.dirty),
            }"
          />
          <!-- <select class="custom-select" formControlName="value">
            <option value="" disabled>Select Value</option>
            @for (option of values; track option; let i = $index) {
                <option [value]="option">{{ option }}</option>
            }
          </select> -->
          @if (
            characteristicsForm.get('value')?.errors?.['required'] &&
            (characteristicsForm.get('value')?.touched || characteristicsForm.get('value')?.dirty)
          ) {
            <div class="d-flex mt-2 errorText gap-2">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>Value cannot be empty.</p>
            </div>
          }
          @if (characteristicsForm.get('value')?.errors?.['minlength']) {
            <div class="d-flex mt-2 errorText gap-2">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>Value must be at least 3 characters long.</p>
            </div>
          }
          @if (characteristicsForm.get('value')?.errors?.['maxlength']) {
            <div class="d-flex mt-2 errorText gap-2">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>Value can not exceed 20 characters.</p>
            </div>
          }
        </div>
      </div>
      <div class="custom-line-top mt-4"></div>
    </mat-dialog-content>
    <mat-dialog-actions class="justify-content-end gap-3 pt-0 pb-3 pr-4">
      <button
        class="btn btn-white border rounded-3 text-black-50 w-25 common-add-btn"
        mat-dialog-close
      >
        Cancel
      </button>
      @if (this.data.characteristic) {
        <button
          type="submit"
          class="btn btn-dark rounded-3 common-add-btn"
          [disabled]="characteristicsForm.invalid"
          (click)="addCharacteristics()"
        >
          Update
        </button>
      } @else {
        <button
          type="submit"
          class="btn btn-dark rounded-3 common-add-btn"
          [disabled]="characteristicsForm.invalid"
          (click)="addCharacteristics()"
        >
          Add Characteristic
        </button>
      }
    </mat-dialog-actions>
  </form>
</div>
